export default {
  zh: {
    rule: '规则',
    classic: '经典',
    master: '大师',
    quick: '快速'
  },
  en: {
    rule: 'RULES',
    classic: 'CLASSIC',
    master: 'MASTER',
    quick: 'QUICK'
  },
  ar: {
    rule: 'RULES',
    classic: '',
    master: '',
    quick: ''
  }
}


// WEBPACK FOOTER //
// src/pages/ludo/ludorule/lang.js